// Turunan status device per aset dari daftar device & pulse. Sengaja NOL IMPORT
// biar bisa dijalanin langsung pakai node.

// Tipe sensor "kesehatan" yang menentukan status no-sensor (selain GPS).
// Aset hanya dianggap bermasalah bila sensor yang MEMANG dimilikinya diam.
export const HEALTH_SENSOR_TYPES = ['rpm', 'flowmeter', 'ae', 'temperature'];

// Group flowmeter yang TIDAK ditampilkan di dashboard FMS.
// BUNKER = jalur isi BBM (ranah bunker dashboard), bukan konsumsi engine.
const EXCLUDED_FLOWMETER_GROUPS = ['BUNKER'];

export function getDeviceStatus(devices) {
  if (!devices || devices.length === 0) {
    return {
      hasExhaustTemperature: false,
      flowmeterType: 'none',
      flowmeterCount: 0,
      flowmeterPositions: [],
      flowmeterGroups: [],
      flowmeterPositionCounts: {
        PORT: 0,
        STARBOARD: 0,
        CENTER: 0,
      },
      hasPowermeter: false,
      powermeterCount: 0,
      aeCount: 0,
      rpmTypes: [],
      rpmCount: 0,
      hasRpm: false,
      hasFlowmeter: false,
      hasAe: false,
      hasTemperature: false,
      healthSensors: [],
    };
  }

  // Check for exhaust temperature sensor
  const hasExhaustTemperature = devices.some(
    (d) => d.devcType === 'temperature' && d.devcLabel === 'EXHAUST_TEMPERATURE',
  );

  // Analyze flowmeters
  const flowmeters = devices.filter((d) => d.devcType === 'flowmeter');
  const flowmeterCount = flowmeters.length;

  let flowmeterType = 'none';
  const flowmeterPositionCounts = {
    PORT: 0,
    STARBOARD: 0,
    CENTER: 0,
  };

  if (flowmeterCount > 0) {
    const hasIn = flowmeters.some((d) => (d.devcLabel || '').includes('_IN'));
    const hasOut = flowmeters.some((d) => (d.devcLabel || '').includes('_OUT'));

    if (hasIn && hasOut) {
      flowmeterType = 'in-out';
    } else if (hasIn) {
      flowmeterType = 'in-only';
    }
  }

  // Get flowmeter positions and count them
  flowmeters.forEach((fm) => {
    if ((fm.devcLabel || '').startsWith('PORT')) {
      flowmeterPositionCounts.PORT += 1;
    } else if ((fm.devcLabel || '').startsWith('STARBOARD')) {
      flowmeterPositionCounts.STARBOARD += 1;
    } else if ((fm.devcLabel || '').startsWith('CENTER')) {
      flowmeterPositionCounts.CENTER += 1;
    }
  });

  const flowmeterPositions = Object.keys(flowmeterPositionCounts).filter(
    (pos) => flowmeterPositionCounts[pos] > 0,
  );

  // Flowmeter groups — label-driven, tak terbatas posisi engine.
  // Nama group = devcLabel tanpa suffix _IN/_OUT (PORT, STARBOARD, CENTER, AE4, AE_INLINE, ...).
  // Satu group bisa punya IN dan/atau OUT (in-out -> bisa hitung net). BUNKER dikecualikan.
  const flowmeterGroupMap = {};
  flowmeters.forEach((fm) => {
    const label = fm.devcLabel || '';
    const name = label.replace(/_(IN|OUT)$/, '');
    if (!name || EXCLUDED_FLOWMETER_GROUPS.includes(name.toUpperCase())) return;
    if (!flowmeterGroupMap[name]) {
      flowmeterGroupMap[name] = { name, hasIn: false, hasOut: false };
    }
    if (label.endsWith('_OUT')) flowmeterGroupMap[name].hasOut = true;
    else flowmeterGroupMap[name].hasIn = true;
  });
  const flowmeterGroups = Object.values(flowmeterGroupMap);

  // Analyze powermeters
  const powermeters = devices.filter((d) => d.devcType === 'powermeter');
  const powermeterCount = powermeters.length;
  const hasPowermeter = powermeterCount > 0;

  // Kapabilitas sensor per-aset (dari device list) untuk status no-sensor.
  const hasRpm = devices.some((d) => d.devcType === 'rpm');
  const hasAe = devices.some((d) => d.devcType === 'ae');
  const hasTemperature = devices.some((d) => d.devcType === 'temperature');
  const hasFlowmeter = flowmeterCount > 0;
  const sensorPresence = {
    rpm: hasRpm,
    flowmeter: hasFlowmeter,
    ae: hasAe,
    temperature: hasTemperature,
  };
  const healthSensors = HEALTH_SENSOR_TYPES.filter((type) => sensorPresence[type]);

  // aeCount dan rpmTypes diderive setelah getLastData — lihat deriveDeviceStatusFromPulse()
  return {
    hasExhaustTemperature,
    flowmeterType,
    flowmeterCount,
    flowmeterPositions,
    flowmeterGroups,
    flowmeterPositionCounts,
    hasPowermeter,
    powermeterCount,
    aeCount: 0,
    rpmTypes: [],
    rpmTypesCount: 0,
    hasRpm,
    hasFlowmeter,
    hasAe,
    hasTemperature,
    healthSensors,
  };
}

export function deriveDeviceStatusFromPulse(assets) {
  return assets.map((asset) => {
    const deviceStatus = { ...(asset.deviceStatus || {}) };

    if (asset.lastAeData && asset.lastAeData.length > 0) {
      const maxNo = asset.lastAeData.reduce((max, item) => (item.no > max ? item.no : max), -1);
      deviceStatus.aeCount = maxNo > -1 ? maxNo + 1 : 0;
    }

    // rpmTypes diturunkan dari tipe yang muncul di pulse RPM:
    // single engine -> cuma CENTER; twin -> PORT/STARBOARD. Tanpa hardcode massId.
    const rpmDevice = (asset.devices || []).find((d) => d.devcType === 'rpm');
    if (rpmDevice && asset.lastRpmData && asset.lastRpmData.length > 0) {
      const uniqueRpmTypes = new Set(asset.lastRpmData.map((item) => item.type));
      deviceStatus.rpmTypes = Array.from(uniqueRpmTypes);
      deviceStatus.rpmTypesCount = deviceStatus.rpmTypes.length;
    }

    return { ...asset, deviceStatus };
  });
}
